import React from "react";
import { Link } from "react-router-dom";
import { CompassMark } from "@/components/CompassMark";
import { NAV, SITE_META } from "@/data/content";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-ink-line bg-ink-base">
      <div className="container-wide py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-4" aria-label="Quentin Young">
              <CompassMark size={56} alt="" />
              <div>
                <p className="font-serif text-xl tracking-[0.12em] uppercase text-paper-primary">Quentin Young</p>
                <p className="eyebrow mt-1">{SITE_META.domain}</p>
              </div>
            </Link>
            <p className="mt-8 max-w-md font-serif text-xl text-paper-secondary leading-relaxed text-pretty">
              {SITE_META.tagline}
            </p>
            <p className="mt-4 max-w-md text-paper-tertiary text-sm leading-relaxed">{SITE_META.intro}</p>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow mb-6">Navigation</p>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-6">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="link-quiet font-sans text-sm" data-testid={`footer-nav-${item.label.toLowerCase()}`}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-6">Work with Quentin</p>
            <ul className="space-y-3 mb-8">
              <li>
                <Link to="/coaching" className="link-quiet font-sans text-sm" data-testid="footer-link-coaching">Coaching</Link>
              </li>
              <li>
                <Link to="/speaking" className="link-quiet font-sans text-sm" data-testid="footer-link-speaking">Speaking</Link>
              </li>
            </ul>
            <p className="text-paper-tertiary text-sm leading-relaxed">
              An evolving body of work. Returns reward patience.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="btn-arrow mt-6 inline-flex"
            >
              <span>Reach out</span>
              <span className="arrow">→</span>
            </Link>
          </div>
        </div>

        <div className="hairline mt-20" />

        <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">
            © {year} Quentin Young. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">
            What you say you are is what survives reality.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
